import { Component, ViewChild } from '@angular/core';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ActivatedRoute } from '@angular/router';
import { CrudFormsComponent } from '../crud-forms/crud-forms.component';
import { FormsViewComponent } from '../forms-view/forms-view.component';

@Component({
  selector: 'app-manage-forms',
  standalone: true,
  imports: [...COMMON_IMPORTS, CrudFormsComponent, DialogModule, ButtonModule, FormsViewComponent],
  templateUrl: './manage-forms.component.html',
})
export class ManageFormsComponent {
  @ViewChild(CrudFormsComponent) crudFormsComponent!: CrudFormsComponent;
  @ViewChild('formsView') formsViewComponent!: FormsViewComponent;

  public showAddFormDialog: boolean = false;
  public orgId: string;

  constructor(private readonly router: ActivatedRoute) {
    this.orgId = this.router.snapshot.paramMap.get('orgId') as string;
  }

  public openAddFormDialog() {
    this.showAddFormDialog = true;
  }

  public closeAddFormDialog() {
    this.showAddFormDialog = false;
    this.crudFormsComponent.onCancel();
  }

  public async onAddFormSuccess() {
    this.showAddFormDialog = false;
    await this.formsViewComponent.reloadForms();
  }
}
